import { List, Map } from 'immutable';
import { createSelector } from 'reselect';

import { selectRelayLoadTypesAsImmutableMap } from '@sophocles/features/reference';

export const relaySelector = state => state.entities.relays;

export function addRelayLoadsToRelays(relays, loads) {
  return createSelector(relays, loads, (relays, relayLoads) => {
    if (relays.isEmpty()) {
      return relays;
    } // breakout if no relay info
    relays = relays.map(relay => relay.set('relay_loads', List()));
    relayLoads.forEach(load => {
      const id = load.get('primary_relay', 0) + ''; // get the relay id for this load
      const tmp = relays.get(id, Map()); // get the actual relay
      const newList = tmp.get('relay_loads', List()).push(load); // create the new list
      relays = relays.set(id, tmp.set('relay_loads', newList)); // add the new entry
    });
    return relays;
  });
}

export function addSchedulesToRelays(relays, schedules) {
  return createSelector(relays, schedules, (relays, schedules) => {
    if (relays.isEmpty()) {
      return relays;
    }
    relays = relays.map(relay => relay.set('schedules', List()));
    schedules.forEach(schedule => {
      const id = schedule.get('relay', 0) + '';
      if (relays.has(id)) {
        const relay = relays.get(id, Map());
        const newList = relay.get('schedules').push(schedule);
        relays = relays.set(id, relay.set('schedules', newList));
      }
    });
    return relays;
  });
}

export function associateRelaysAndRemoveThem(relays) {
  return createSelector(relays, relays => {
    if (relays.isEmpty()) {
      return relays;
    }
    let list = new List();
    relays = relays.map(relay => {
      if (relay.get('secondary_relay')) {
        list = list.push(relay.get('secondary_relay'));
        relay = relay.set('secondary_relay', relays.get(relay.get('secondary_relay') + ''));
      }
      return relay;
    });

    list.forEach(id => {
      relays = relays.remove(id + '');
    });
    return relays;
  });
}

export function addRelayLoadTypeToRelays(relaySelector, defaultValue) {
  return createSelector(relaySelector, selectRelayLoadTypesAsImmutableMap, (relays, types) =>
    relays.map(relay =>
      relay.set(
        'load_type',
        types.get(relay.get('load_type', '0') ? relay.get('load_type') + '' : defaultValue, Map()),
      ),
    ),
  );
}
